import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import index from './views/index.vue'
import ProductService from './views/ProductService.vue'
import Safety from './views/Safety.vue'
import ContactUs from './views/ContactUs.vue'
import AboutUs from './views/AboutUs.vue'
import ReceiptOrder from './views/ReceiptOrder.vue'
import Collection from './views/Collection.vue'
import Overlay from './views/Overlay.vue'
import AMLStatement from './views/AMLStatement.vue'
import CookiePolicy from './views/CookiePolicy.vue'
import TermsofUse from './views/TermsofUse.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'
import ValueAddedService from './views/ValueAddedService.vue'


export default new Router({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/ProductService',
      name: 'ProductService',
      component: ProductService
    },
    {
      path: '/Safety',
      name: 'Safety',
      component: Safety
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/ReceiptOrder',
      name: 'ReceiptOrder',
      component: ReceiptOrder
    },
    {
      path: '/Collection',
      name: 'Collection',
      component: Collection
    },
    {
      path: '/Overlay',
      name: 'Overlay',
      component: Overlay
    },
    {
      path: '/TermsofUse',
      name: 'Terms of Use',
      component: TermsofUse
    },
    {
      path: '/AMLStatement',
      name: 'AML Statement',
      component: AMLStatement
    },
    {
      path: '/CookiePolicy',
      name: 'Cookie Policy',
      component: CookiePolicy
    },
    {
      path: '/PrivacyPolicy',
      name: 'Privacy Policy',
      component: PrivacyPolicy
    },
    {
      path: '/ValueAddedService',
      name: 'Value-added Service',
      component: ValueAddedService
    }
  ]
})
